import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAPIReceiptsEndpoint, Endpoint } from "../../Services/Receipts/ReceiptsService";
import storage from "../../Services/Storage";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";

const PaymentAllRecords = () => {
    const nav = useNavigate();
    const auth = storage.getLocal("user");
    const [paymentListData, setPaymentListData] = useState([]);
    const [statuses] = useState(["Cash", "Cheque", "PQR"]);
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());


    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select One" className="p-column-filter" showClear style={{ maxWidth: "12rem" }} />
        );
    };

    const getPaymentListData = () => {
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startDate);
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        createAPIReceiptsEndpoint()
            .get(`${Endpoint.GetAllPaymentList}?StartDate=${formattedStartDate}&EndDate=${formattedEndDate}&CompId=${auth.CompId}`)
            .then((response) => {
                console.log("response.data.length ",response.data.length);
                if (response.data.length <= 0) {
                    toast.warning(
                        "No data found",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        }

                    );
                }
                setPaymentListData(response.data);
            })
            .catch((err) => {
                console.log("error ", err);
            });
        // createAPIReceiptsEndpoint()
        //     .get(`${Endpoint.GetAllPaymentList}?StartDate=23/03/2012&EndDate=17/03/2025&CompId=13306749`)
        //     .then((response) => {

        //         setPaymentListData(response.data);
        //     })
        //     .catch((err) => {
        //         console.log("error ", err);
        //     });
    };
    useEffect(() => {
        getPaymentListData();
    }, []);
    return (
        <>

            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Payments</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button type="button" className="btn btn-primary" onClick={() => nav("/creditmanagement/payment/details")}>Add New Payment</button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} showIcon required />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} showIcon required />
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12">
                                <div className="float-end">
                                    <button type="button" className="btn btn-primary" onClick={getPaymentListData}>Get Data</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <section className="mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3>Records</h3>
                        <div className="DataTable pb-4 pt-1">
                            <DataTable
                                value={paymentListData}
                                paginator
                                rows={10}
                                // showGridlines
                                stripedRows
                                filterDisplay="row"
                                emptyMessage="No Receipts found."
                                rowsPerPageOptions={[10, 25, 50]}
                                tableStyle={{ minWidth: "50rem" }}
                            >
                                <Column
                                    field="PAYMENT_NO"
                                    header="Payment Number"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="DOCUMENT_DATE"
                                    header="Payment Date"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="SUPPLIER"
                                    header="Supplier Name"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="PAYMENT_MODE"
                                    header="Mode of Payment"
                                    // body={modeStatus}
                                    showFilterMenu={false} filter filterElement={statusRowFilterTemplate} style={{ minWidth: "12rem" }}
                                ></Column>
                                <Column header="Action " body={(rowData) => (
                                    <button
                                        className="grid-icon-img"
                                        title="View/Edit"
                                        onClick={() => {
                                            console.log("rowData ",rowData);
                                            nav(`/creditmanagement/payment/details?RCVHID=${encodeURIComponent(rowData.PAYMENT_ID)}`);
                                        }}
                                    >
                                        <img
                                            alt="InnoRise"
                                            width="20px"
                                            src={require("../../Assets/Images/ViewEdit.png")}
                                        />
                                    </button>
                                )}></Column>
                            </DataTable>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PaymentAllRecords;